export const menuItems = [
	{ label: "Home", href: "/" },
	{ label: "Works", href: "/portfolio" },
	{ label: "Blog", href: "https://blog.amantripathi.dev/" },
	{ label: "About", href: "/about" },
	{ label: "Contact", href: "/contact" },
];

export const socialLinks = [
	{ label: "Instagram", href: "https://instagram.com/aman.css" },
	{ label: "X", href: "https://x.com/Imamantripathi1" },
	{ label: "LinkedIn", href: "https://www.linkedin.com/in/imamantripathi/" },
	{ label: "GitHub", href: "https://github.com/imamantripathi" }
];
